<template>
  <div id="verify-message">
    <h1>{{ $t("onboard.verifyMessage.header") }}</h1>
    <p v-html="$t('onboard.verifyMessage.text')"></p>
  </div>
</template>

<script>
export default {
  name: 'VerifyMessage'
}
</script>
<style scoped type="scss">
#verify-message {
  margin-bottom: 45px;
  padding-top: 120px;
  background: url('../../assets/icons/onboard-email.png') no-repeat center top;
  text-align: center;
}
</style>
